module.exports = __webpack_public_path__ + "static/img/cologo.5f3ddd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/coopera/images/cologo.png
// module id = WW1E
// module chunks = 1